import React from 'react';
import styled, { css } from 'react-emotion';
import Bar from './Bar';
import Title from '../../../Symbols/Title';

const Row = styled.div`
	padding: 1rem 1rem 1rem 2.5rem;
	background-color: #f2f2f2;
	margin: 0.1rem;
	
	@media (max-width: 480px) {
		padding: 1rem;
	}
`;

const Results = styled.div`
	display: flex;
	align-items: flex-end;
`;

const BarWrapper = styled.div`
	position: relative;
	flex: 3;
	@media (max-width: 480px) {
		display: none;
	}
`;

const Numbers = styled.div`
	flex: 2;
	display: flex;
	& > div {
		text-align: center;
		margin-left: 1rem;
		&:first-child {
				margin-left: 2.5rem;
			}
		@media (max-width: 480px) {
			margin-top: 1rem;
			&:first-child {
				margin-left: 0;
			}
		}
	}
	& ${Title} {
		border-bottom: none;
	}
`;

const Bold = css`
	font-weight: bold;
`;

const Defending = styled.div`
	@media (min-width: 481px) {
		display:none;
	}
`

const DefendingMandatesWrapper = styled.div`
	display: block;
	position: absolute;
	top: -32px;
`

const DefendingMandates = styled.div`
    position: relative;
    height: 72px;
    display: block;
    width: 1px;
    
    ${Title} {
		position: absolute;
		left: -30px;
		border-bottom: none;
    }
`

const Mandates = styled.div`
	position: absolute;
    bottom: -10px;
    left: -3px;
`
const Line = styled.div`
    position: absolute;
    height: 32px;
    width: 1px;
    border-right: 1px dashed #000;
    top: 24px;
`
const RowTitle= styled.div`
	@media (min-width: 480px) {
		margin-bottom: 20px;
	}
`
const Up = styled.span`
	color: green;
`;

const Down = styled.span`
	color: red;
`;

const Same = styled.span`
	color: blue;
`;


const getTrend = (difference) => {
	if (difference === 0) {
		return <Same>➡</Same>;
	}
	if (difference < 0) {
		return <Down>⬊</Down>;
	}
	return <Up>⬈</Up>;
};

export default ({ name, actualMandates, senators = 0, max, ...item }) => {
	const difference = senators - actualMandates;
	const indicatorPosition = actualMandates * (100/max);
	return (
		<Row>
			<RowTitle>{name}</RowTitle>
			<Results>
				<BarWrapper>
					<Bar {...item} max={max} getValue={() => senators} />
					<DefendingMandatesWrapper style={{ left: `calc(${indicatorPosition}% - 1px)` }}>
						<DefendingMandates>
							<Title>
								Obhajuje
							</Title>
							<Line />
							<Mandates>
								{actualMandates}
							</Mandates>
						</DefendingMandates>
					</DefendingMandatesWrapper>
				</BarWrapper>
				<Numbers>
					<div>
						<Title className={Bold}>Celkem</Title>
						<Title className={Bold}>{senators}</Title>
					</div>
					<Defending>
						<Title>Obhajuje</Title>
						<Title className={Bold}>{actualMandates}</Title>
					</Defending>
					<div>
						<Title>Změna</Title>
						<Title className={Bold}>
							{difference > 0 ? '+' : ''}
							{difference}
						</Title>
					</div>
					<div>
						<div>&nbsp;</div>
						<div>{getTrend(difference)}</div>
					</div>
				</Numbers>
			</Results>
		</Row>
	);
};
